import { LinkTo } from '@ember/routing';
import mobileMenu from '../../../packages/mobile-menu';
import MobileMenuToggle from '../../../modifiers/mobile-menu-toggle';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { useQuery } from 'glimmer-apollo';
import { gql } from 'glimmer-apollo';
import LoadingSpinner from '../../loading/spinner';

const FEATURED_ARTICLES_QUERY = gql`
  query {
    articles: eSportsArticles(limit: 3) {
      __typename
      title
      slug
      publishedDate
      shortDescription
      coverImage {
        url
      }
      author {
        displayName
        slug
        profilePicture {
          url
        }
      }
    }
  }
`;

export default class MobileNavComponent extends Component {
  query = useQuery(this, () => [FEATURED_ARTICLES_QUERY]);

  get topGames() {
    return [
      { name: 'SMITE', slug: 'smite' },
      { name: 'VALORANT', slug: 'valorant' },
      { name: 'League of Legends', slug: 'league-of-legends' },
      { name: 'Counter-Strike', slug: 'counter-strike' },
      { name: 'Fortnite', slug: 'fortnite' },
      { name: 'Apex Legends', slug: 'apex-legends' },
      { name: 'Crystal of Atlan', slug: 'crystal-of-atlan' }
    ];
  }

  get featuredTeams() {
    return [
      { name: 'Oni Warriors', slug: 'oni-warriors' },
      { name: 'Jade Dragons', slug: 'jade-dragons' },
      { name: 'Styx Ferrymen', slug: 'styx-ferrymen' },
      { name: 'Atlantis Leviathans', slug: 'atlantis-leviathans' }
    ];
  }

  get recentMatches() {
    return [
      { name: 'Smite - SWCX: Grand Finals', slug: 'smite-world-championship-season-x-grand-finals' },
      { name: 'Smite - SWCX: SF Match 2', slug: 'smite-world-championship-season-x-semifinals-match-2' },
      { name: 'Smite - SWCX: SF Match 1', slug: 'smite-world-championship-season-x-semifinals-match-1' },
      { name: 'Smite - SWCX: QF Match 4', slug: 'smite-world-championship-season-x-quarterfinals-match-4' },
      { name: 'Smite - SWCX: QF Match 3', slug: 'smite-world-championship-season-x-quarterfinals-match-3' },
      { name: 'Smite - SWCX: QF Match 2', slug: 'smite-world-championship-season-x-quarterfinals-match-2' },
      { name: 'Smite - SWCX: QF Match 1', slug: 'smite-world-championship-season-x-quarterfinals-match-1' }
    ];
  }

  get featuredPlayers() {
    return [
      { name: 'Paul', slug: 'paul' },
      { name: 'Adapting', slug: 'adapting' },
      { name: 'PandaCat', slug: 'pandacat' },
      { name: 'Nika', slug: 'nika' }
    ];
  }

  get featuredArticles() {
    return this.query.data?.articles ?? [];
  }

<template>
  <style>
    .mobile-dropdown.active { display: block; }
    
    /* Mobile menu backdrop for outside click */
    .mobile-menu-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: var(--z-drawer-backdrop);
      opacity: 1;
      transition: opacity 0.3s ease;
    }
    
    /* Improved close button with larger touch target */
    .mobile-menu-close-button {
      position: absolute;
      top: 22px;
      right: 12px;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 1001;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      transition: background-color 0.2s ease;
    }
    
    .mobile-menu-close-button:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    
    .mobile-menu-close-button:active {
      background: rgba(255, 255, 255, 0.2);
    }
    
    .mobile-menu-wrap .mobile-menu-close {
      width: 24px;
      height: 24px;
      fill: #fff;
    }
    
    .mobile-menu-wrap .logo-img {
      width: 52px;
      height: 41px;
      position: absolute;
      top: 22px;
      left: 20px;
      z-index: 1;
    }
  </style>
  
  {{!-- Mobile Top Bar with Gradient --}}
  <div class='mobile-top-bar'>
    <button type='button' class='mobile-menu-button' {{on 'click' (fn @openMobileMenu true)}}>
      <svg class='menu-pull-icon'><use href='#svg-menu-pull'></use></svg>
    </button>
    <button type='button' class='mobile-search-button' {{on 'click' (fn @openSearch true)}}>
      <svg class='search-icon'><use href='#svg-search'></use></svg>
    </button>
  </div>
  
  {{!-- Mobile Bottom Navigation Bar --}}
  <div class='mobile-nav-bar'>
    <LinkTo @route='index' class='mobile-nav-link'>
      <svg class='nav-icon'><use href='#svg-plus-big'></use></svg>
      <span class='nav-label'>Home</span>
    </LinkTo>
    
    <LinkTo @route='news' class='mobile-nav-link'>
      <svg class='nav-icon'><use href='#svg-bullet-big'></use></svg>
      <span class='nav-label'>News</span>
    </LinkTo>
    
    <LinkTo @route='esports' class='mobile-nav-link'>
      <svg class='nav-icon'><use href='#svg-shield-big'></use></svg>
      <span class='nav-label'>eSports</span>
    </LinkTo>
  </div>
  
  {{!-- Backdrop for outside click --}}
  {{#if @isMobileMenuOpen}}
    <div class='mobile-menu-backdrop' {{on 'click' (fn @openMobileMenu false)}}></div>
  {{/if}}
  
  <div class='mobile-menu-wrap {{if @isMobileMenuOpen "open"}}' {{mobileMenu}}>
    {{!-- Close button with larger touch target --}}
    <button type='button' class='mobile-menu-close-button' {{on 'click' (fn @openMobileMenu false)}} aria-label='Close mobile menu'>
      <svg class='cross-icon big mobile-menu-close'>
        <use href='#svg-cross-big'></use>
      </svg>
    </button>
    <figure class='logo-img'>
      <img alt='Logo' src='/img/brand/logo.png' />
    </figure>
    <ul class='mobile-menu'>
      <li class='mobile-menu-item'>
        <LinkTo @route='application' class='mobile-menu-item-link'>Home</LinkTo>
      </li>
      <li class='mobile-menu-item'>
        <LinkTo @route='news' class='mobile-menu-item-link'>News</LinkTo>
      </li>
      <li class='mobile-menu-item'>
        <p class='mobile-menu-item-link pd-dropdown-handler' {{MobileMenuToggle}}>eSports</p>
        <svg class='arrow-icon medium'>
          <use href='#svg-arrow-medium'></use>
        </svg>
        <ul class='mobile-dropdown pd-dropdown'>
          {{!-- Main Pages --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Main Pages</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              <li class='mobile-dropdown-item'>
                <LinkTo @route='esports' class='mobile-dropdown-item-link'>eSports Home</LinkTo>
              </li>
            </ul>
          </li>
          
          {{!-- Top Games --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Top Games</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              {{#each this.topGames as |game|}}
                <li class='mobile-dropdown-item'>
                  <LinkTo @route='esports.game' @model={{game.slug}} class='mobile-dropdown-item-link'>{{game.name}}</LinkTo>
                </li>
              {{/each}}
            </ul>
          </li>
          
          {{!-- Featured Teams --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Featured Teams</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              {{#each this.featuredTeams as |team|}}
                <li class='mobile-dropdown-item'>
                  <LinkTo @route='esports.team' @model={{team.slug}} class='mobile-dropdown-item-link'>{{team.name}}</LinkTo>
                </li>
              {{/each}}
            </ul>
          </li>
          
          {{!-- Featured Players --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Featured Players</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              {{#each this.featuredPlayers as |player|}}
                <li class='mobile-dropdown-item'>
                  <LinkTo @route='esports.player' @model={{player.slug}} class='mobile-dropdown-item-link'>{{player.name}}</LinkTo>
                </li>
              {{/each}}
            </ul>
          </li>
          
          {{!-- Recent Tournaments --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Recent Tournaments</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              <li class='mobile-dropdown-item'>
                <LinkTo @route='esports.tournament' @model='smite-world-championship-season-x' class='mobile-dropdown-item-link'>Smite - SWCX</LinkTo>
              </li>
            </ul>
          </li>
          
          {{!-- Recent Matches --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Recent Matches</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              {{#each this.recentMatches as |match|}}
                <li class='mobile-dropdown-item'>
                  <LinkTo @route='esports.matches.match' @model={{match.slug}} class='mobile-dropdown-item-link'>{{match.name}}</LinkTo>
                </li>
              {{/each}}
            </ul>
          </li>
          
          {{!-- Featured Articles --}}
          <li class='mobile-dropdown-item'>
            <p class='mobile-dropdown-item-link pd-dropdown-handler' {{MobileMenuToggle}}>Featured Articles</p>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
            <ul class='mobile-dropdown pd-dropdown'>
              {{#if this.query.loading}}
                <li class='mobile-dropdown-item'>
                  <div class='mobile-dropdown-item-link'>Loading articles...</div>
                </li>
              {{else if this.query.error}}
                <li class='mobile-dropdown-item'>
                  <div class='mobile-dropdown-item-link'>Error loading articles</div>
                </li>
              {{else}}
                {{#each this.featuredArticles as |article|}}
                  <li class='mobile-dropdown-item'>
                    <LinkTo @route='esports.post' @model={{article.slug}} class='mobile-dropdown-item-link'>{{article.title}}</LinkTo>
                  </li>
                {{/each}}
              {{/if}}
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
}
